module.exports = "<svg viewBox=\"0 0 12 15\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M11.333 15H.667C.299 15 0 14.72 0 14.375s.299-.625.667-.625h10.666c.368 0 .667.28.667.625s-.299.625-.667.625zM6 12.5c-2.791 0-4.667-1.758-4.667-4.375v-7.5C1.333.28 1.632 0 2 0c.368 0 .667.28.667.625v7.5c0 1.928 1.277 3.125 3.333 3.125s3.333-1.197 3.333-3.125v-7.5C9.333.28 9.632 0 10 0c.368 0 .667.28.667.625v7.5C10.667 10.742 8.79 12.5 6 12.5z\" fill=\"#425964\" fill-rule=\"evenodd\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-inline-loader?removeTags=true!./src/scripts/components/playbook/components/Editor/plugins/blockStyles/underline.svg
// module id = Ala6
// module chunks = 89